/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="93.8"
        height="95.59"
        viewBox="0 0 93.8 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M86.96 0H60.09a6.84 6.84 0 0 0-6.84 6.84v17.39a6.85 6.85 0 0 0 6.84 6.6h4.19v6.57a1.25 1.25 0 0 0 2 .84l8.73-7.41h11.95A6.89 6.89 0 0 0 93.8 24V6.84A6.84 6.84 0 0 0 86.96 0ZM60.09 2.5h26.87a4.34 4.34 0 0 1 4.34 4.34V24a4.37 4.37 0 0 1-4.34 4.34h-12.5a1.27 1.27 0 0 0-.66.29l-7 5.95v-5a1.25 1.25 0 0 0-1.25-1.25h-5.46A4.35 4.35 0 0 1 55.75 24V6.84a4.34 4.34 0 0 1 4.34-4.34Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M82.46 17.88a2.31 2.31 0 1 0-2.31-2.31 2.3 2.3 0 0 0 2.29 2.31M73.53 17.88a2.31 2.31 0 1 0-2.31-2.31 2.3 2.3 0 0 0 2.29 2.31M64.64 17.88a2.31 2.31 0 1 0-2.3-2.32 2.3 2.3 0 0 0 2.29 2.31"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M29.06 4H5.96a6 6 0 0 0-6 6v15a6.06 6.06 0 0 0 6 5.82h10.19l7.43 6.31.1.08a1.26 1.26 0 0 0 1.75-.21 1.27 1.27 0 0 0 .25-.75v-5.42h3.38a6 6 0 0 0 6-5.95V10.07a6.05 6.05 0 0 0-6-6.07ZM5.96 6.5h23.1a3.55 3.55 0 0 1 3.55 3.55v14.74a3.53 3.53 0 0 1-3.54 3.54h-4.81a1.24 1.24 0 0 0-1.12 1.24v3.91l-5.68-4.85a1.24 1.24 0 0 0-.8-.3H5.96a3.57 3.57 0 0 1-3.5-3.54V10.07a3.53 3.53 0 0 1 3.5-3.55Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M9.96 19.54a2 2 0 1 1 2-2 2 2 0 0 1-2 2M17.53 19.54a2 2 0 1 1 2-2 2 2 0 0 1-2 2M25.15 19.54a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M55.75 47.42H33.36V81h22.39Zm-2.5 2.5v28.6H35.86v-28.6Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M47.62 87.05a3.07 3.07 0 1 1-3.09-3 3.06 3.06 0 0 1 3.06 3.06"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M60.6 40.09H28.51a1.25 1.25 0 0 0-1.25 1.25v53a1.25 1.25 0 0 0 1.25 1.25H60.6a1.25 1.25 0 0 0 1.25-1.25v-53a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v50.49H29.76V42.59Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'MobileDeviceWithTwoWordBubblesIcon';

export default Icon;
